import React from 'react'
import classNames from 'classnames'

import { Button } from 'pharmacy/src/input/button'

import { useFlags } from 'launchdarkly-react-client-sdk'

import css from './headerRegisterButton.scss'

export const HeaderRegisterButton = ({ pathname }) => {
  const { useV2Onboarding } = useFlags()

  const registerUrl = useV2Onboarding ? '/v2/onboarding' : '/register'

  const urlSearch = {
    ...(useV2Onboarding && { mode: 'signUp' }),
    src: pathname.replace(/^\/+/, '') || 'public_home', // remove leading forward slash
    src_path: pathname,
    src_item: 'header',
  }

  return (
    <>
      <Button
        type="dark_blue"
        className={classNames(css.button, css.displayForLargeScreen)}
        pathname={registerUrl}
        params={urlSearch}
        external={useV2Onboarding}
      >
        <div className={css.buttonText}>Register</div>
      </Button>
      <Button
        type="orange"
        className={classNames(css.button, css.displayForSmallScreen)}
        pathname={registerUrl}
        params={urlSearch}
        external={useV2Onboarding}
      >
        <div className={css.buttonText}>Register</div>
      </Button>
    </>
  )
}
